import React from 'react'
import useWindowSize from '../../hooks/useWindowSize'
import FooterSection from './components/FooterSection'
import OurCompanies from './components/OurCompanies'
import './index.css'

const Footer = () => {
  const { isMobile } = useWindowSize()

  return (
    <>
      <div className="footer-wrapper">
        <FooterSection isMobile={isMobile} />
        <OurCompanies />
      </div>
    </>
  )
}

export default Footer
